export const analyticsDashboardAppGroupIdGetCampaignsForFilter =
  "/analytics_dashboard/:app_group_id/get_campaigns_for_filter";
